import {getEntryPointDataFailed, getEntryPointDataSuccess} from 'modules/actions/entryActions';

import {fetchPlayersSaga, fetchSuggestedPlayersSaga, fetchPlayersSelectedJsoSaga} from 'modules/sagas/players';
import fetchRoundsSaga from 'modules/sagas/rounds';
import {fetchSettingSaga} from 'modules/sagas/settings';
import fetchSquadsSaga from 'modules/sagas/squads';
import fetchUnitsSaga, {fetchHistoryUnitsSaga} from 'modules/sagas/units';
import {all, call, put} from 'typed-redux-saga';
import fetchRewardStatsSaga from 'modules/sagas/rewardStats';
import {fetchFavoriteSquads} from 'modules/actions/user';
import {fetchFavoritePlayersSaga} from 'modules/sagas/user';

export const getEntryPointDataSaga = function* () {
	try {

		const sagas = [
			fetchPlayersSaga,
			fetchSuggestedPlayersSaga,
			fetchFavoritePlayersSaga,
			fetchPlayersSelectedJsoSaga,
			fetchRoundsSaga,
			fetchSquadsSaga,
			fetchUnitsSaga,
			fetchHistoryUnitsSaga,
			fetchRewardStatsSaga,
			fetchSettingSaga,
		];

		yield* all(sagas.map(call));
		yield* put(fetchFavoriteSquads());
		yield* put(getEntryPointDataSuccess());
	} catch (e) {
		console.error('Error getting entry point', e);
		yield* put(getEntryPointDataFailed());
	}
};
